import { AutorisationsService } from './autorisations.service';

/**
 * La méthode ne sera pas appelée si l'utilisateur est supergestionnaire
 */
export function IfNotSuperGestionnaire() {
    return (target: unknown, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;
        const emptyMethod = () => {};
        descriptor.value = function(...args: unknown[]) {
            if (!AutorisationsService.instance) {
                throw new Error(`AutorisationsService n'est pas injecté dans ce composant`);
            }
            return AutorisationsService.instance?.isSuperGestionnaire$.subscribe((isSuperGestionnaire: boolean) => {
                return isSuperGestionnaire ? emptyMethod.apply(this) : originalMethod.apply(this, args);
            });
        };
        return descriptor;
    };
}

/**
 * La méthode sera appelée si l'utilisateur n'a pas le traitement fourni en paramètre
 */
export function IfIsNotAuthorized(traitement: string) {
    return (target: unknown, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;
        const emptyMethod = () => {};
        descriptor.value = function(...args: unknown[]) {
            if (!AutorisationsService.instance) {
                throw new Error(`AutorisationsService n'est pas injecté dans ce composant`);
            }
            return AutorisationsService.instance?.isAutorise$(traitement).subscribe((estAutorise: boolean) => {
                return estAutorise ? emptyMethod.apply(this) : originalMethod.apply(this, args);
            });
        };
        return descriptor;
    };
}

/**
 * La méthode sera appelée si l'utilisateur a le traitement fourni en paramètre
 */
export function IfIsAuthorized(traitement: string) {
    return (target: unknown, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;
        const emptyMethod = () => {};
        descriptor.value = function(...args: unknown[]) {
            if (!AutorisationsService.instance) {
                throw new Error(`AutorisationsService n'est pas injecté dans ce composant`);
            }
            return AutorisationsService.instance?.isAutorise$(traitement).subscribe((estAutorise: boolean) => {
                return !estAutorise ? emptyMethod.apply(this) : originalMethod.apply(this, args);
            });
        };
        return descriptor;
    };
}
